import { isPhoto } from "../../utils/checkFiletype.js";
import { savefeedbackform } from "../../utils/apiFunctions.js";
import { clearCookies } from "../../utils/tokenCheck.js";
import { mapGetters } from "vuex";
import { getLoggedInUserEmail } from "../../utils/request";
import { getToken } from "../../utils/tokenCheck.js";
import jwt_decode from "jwt-decode";

const panelMixins = {
  name: "panelMixins",
  computed: {
    combinedPanelists() {
      const panelistEmails =
        this.interviewDetails?.panelist?.map((panelist) => panelist.email) ||
        [];
      const externalPanelists = this.interviewDetails.externalPanelist || [];
      return [
        [...panelistEmails, ...externalPanelists].join(", "),
        [...panelistEmails, ...externalPanelists],
      ];
    },
    ...mapGetters("userVUEX", {
      extPanel: "getLoggedInUserEmail",
      roleValues: "getRoleValues",
    }),
  },
  props: {
    isLaptop: Boolean,
  },
  created() {
    this.getPanelDetails();
    this.getDate();
    let email = getLoggedInUserEmail();
    this.$store.commit("userVUEX/saveUserEmail", email);
  },

  methods: {
    checkPanelConditions() {
      if (
        this.$v.recommendation.$invalid ||
        this.$v.recruiterRemarks.$invalid ||
        this.$v.skills.$invalid
      ) {
        this.showErrorImage = true;

        this.errorModal("Please fill all fields");
      } else if (
        this.candidateImage == "" &&
        this.panelDetails.screenshot == true &&
        !this.$v.recommendation.$invalid &&
        !this.$v.recruiterRemarks.$invalid &&
        !this.$v.skills.$invalid
      ) {
        this.showErrorImage = true;

        this.errorModal("Please upload file");
      } else if (
        this.candidateImage != "" &&
        !this.$v.recommendation.$invalid &&
        !this.$v.recruiterRemarks.$invalid &&
        !this.$v.skills.$invalid
      ) {
        this.showErrorImage = false;
      }
    },
    async sendFeedback() {
      try {
        if (this.recommendation == "DNA" || this.recommendation == "NI") {
          this.$v.recruiterRemarks.$touch();
          if (this.$v.recruiterRemarks.$invalid) {
            this.errorModal("Please fill all fields");
          } else {
            await this.sendExtFeedback();
          }
        } else {
          this.$v.$touch();
          if (
            (!this.$v.recommendation.$invalid &&
              !this.$v.recruiterRemarks.$invalid &&
              !this.$v.skills.$invalid &&
              this.panelDetails.screenshot == false) ||
            (!this.$v.recommendation.$invalid &&
              !this.$v.recruiterRemarks.$invalid &&
              !this.$v.skills.$invalid &&
              this.panelDetails.screenshot &&
              this.showErrorImage == false &&
              this.candidateImage != "") ||
            (this.interviewResponse &&
              this.interviewResponse.skills == null &&
              !this.$v.recommendation.$invalid &&
              !this.$v.recruiterRemarks.$invalid)
          ) {
            await this.sendExtFeedback();
          } else {
            this.checkPanelConditions();
          }
        }
      } catch (error) {
        this.feedbackLoader = false;

        console.error("Error in sendFeedback:", error);
      }
    },
    // Method to set the current date
    async sendExtFeedback() {
      this.feedbackLoader = true;
      // Create a new FormData object to store form data
      let form = new FormData();

      // Assign the selected image to the candidateImage property

      // Prepare the image data to be sent in the form
      if (this.recommendation != "DNA" && this.recommendation != "NI") {
        if (this.isLaptop) {
          form.append("candidateImage", this.candidateImage);
        } else {
          form.append("candidateImage", this.image);
        }
      }
      if (this.showRecOptions) {
        form.append("feedbackLevelID", this.recOption);
        form.append("feedbackTypeID", this.thirdPartyData.feedbackTypeID);
      }
      // Append various other data to the FormData object
      form.append("interviewID", this.interviewDetails.interviewID);
      form.append("name", this.candidateInfo.fullName);
      form.append("panelName", this.extPanel);
      form.append("processedBy", this.processedBy);
      form.append("licenseKey", this.interviewDetails.licenseKey);
      let tokenData = jwt_decode(getToken());
      form.append("createdBy", tokenData.sub);
      form.append("createdFor", tokenData.email);
      this.processedBy = "Panel";

      // Construct the customFeedback object with various data
      this.customFeedback["licenseKey"] = this.panelDetails.licenseKey;
      this.customFeedback["feedbackFormID"] = this.panelDetails.feedbackFormID;
      this.customFeedback["name"] = this.panelDetails.name;
      this.customFeedback["basicInfo"] = {};
      this.customFeedback.basicInfo["name"] = this.candidateInfo.fullName;
      this.customFeedback.basicInfo["evalDate"] = this.getCurrentDate;
      this.customFeedback.basicInfo["panel"] = this.panelName;
      this.customFeedback.basicInfo["modeOfInterview"] = this.modeOfInterview;
      if (this.recommendation != "DNA" && this.recommendation != "NI") {
        this.customFeedback["skills"] = this.skills;
        this.customFeedback["screenshot"] = this.panelDetails.screenshot;
        this.customFeedback["screenshotMedia"] =
          this.panelDetails.screenshotMedia;
      } else {
        delete this.customFeedback.skills;
        delete this.customFeedback.screenshot;
        delete this.customFeedback.screenshotMedia;
      }
      this.customFeedback["recommendation"] = this.recommendation;
      this.customFeedback["recommendationComments"] =
        this.panelDetails.recommendationComments;
      this.customFeedback["active"] = this.panelDetails.active;
      this.customFeedback["createdBy"] = this.panelDetails.createdBy;
      this.customFeedback["createdAt"] = this.panelDetails.createdAt;
      this.customFeedback["updatedAt"] = this.panelDetails.updatedAt;

      // Append the customFeedback object as JSON to the FormData
      form.append("customFeedback", JSON.stringify(this.customFeedback));

      // Append additional data to the FormData
      form.append("recommendation", this.recommendation);
      form.append("recruiterRemarks", this.recruiterRemarks);

      // Send the form data to the server and await the response
      const res = await savefeedbackform(form);
      if (res.status == 200) {
        this.feedbackLoader = false;
        this.successModal("Feedback submitted successfully");
        this.$bvModal.hide("fillfeedback");

        this.getPanelDetails();
      } else if (res.status == 409) {
        this.feedbackLoader = false;

        this.errorModal("Candidate is already selected in other JD");
      } else {
        this.feedbackLoader = false;
        this.errorModal("Something went wrong!");
      }
    },
    getDate() {
      // Get the current date
      const date = new Date();

      // Extract day, month, and year components
      let day = date.getDate();
      let month = date.getMonth() + 1; // Adding 1 to get the correct month
      let year = date.getFullYear();

      // Create a formatted date string
      this.getCurrentDate = `${day}-${month}-${year}`;
    },
    removeImage() {
      this.image = "";
      this.candidateImage = "";

      this.checkimage = false;
    },
    checkPanelLogin() {
      this.showSpinner = true;
      this.$store.commit("userVUEX/setPanelID", this.$route.query.uuid);
      this.$store
        .dispatch("userVUEX/checkPanelLogin")
        .then((res) => {
          if (res == 200) {
            this.showSpinner = false;
          } else {
            clearCookies();
            this.$store.commit("userVUEX/setPanelID", null);
            location.replace(
              `https://app.hire3x.com/login?from=recruitment&uuid=${this.$route.query.uuid}&panel=${this.$route.query.panel}`
              // `http://localhost:8080/login?from=recruitment&uuid=${this.$route.query.uuid}&panel=${this.$route.query.panel}`
            );
          }
        })
        .catch((err) => {
          clearCookies();
          this.$store.commit("userVUEX/setPanelID", null);
          location.replace(
            `https://app.hire3x.com/login?from=recruitment&uuid=${this.$route.query.uuid}&panel=${this.$route.query.panel}`
            // `http://localhost:8080/login?from=recruitment&uuid=${this.$route.query.uuid}&panel=${this.$route.query.panel}`
          );
          throw err;
        });
    },
    previewImage: function (event) {
      let input = event.target;
      if (input?.files?.[0]) {
        let reader = new FileReader();
        this.image = input.files[0];

        reader.readAsDataURL(input.files[0]);
        let parts = input.files[0].name.split(".");
        this.screenshotname = input.files[0].name;
        let fileSizeInBytes = input.files[0].size;

        let fileSizeInMB = fileSizeInBytes / (1024 * 1024);
        if (this.image != "" && fileSizeInMB <= 5) {
          this.fileCheckImage = true;
        } else if (this.image != "" && fileSizeInMB > 5) {
          this.fileCheckImage = false;
        }
        let ext = parts[parts.length - 1];
        this.candidateImage = ext;
        this.showErrorImage = false;

        if (!isPhoto(this.candidateImage)) {
          this.isFailed = true;
          this.checkimage = false;
          this.showErrorImage = false;
          // IF the File Type is invalid then delete "QUESTION MEDIA" / "MEDIA TYPE" from the PAYLOAD
          this.image = "";
          delete this.feedback.candidateImage;
        } else {
          // FOR getting the extension of a particular file
          this.checkimage = true;
          this.isFailed = false;
          this.image = input.files[0];
          // FOR Checking if the fileType is valid or NOT
          reader.onload = (e) => {
            this.candidateImage = e.target.result;
            this.$forceUpdate();
          };
        }
      }
      event.target.value = "";
    },
  },
};
export default panelMixins;
